// extracted by mini-css-extract-plugin
export default {"orders-wrapper":"orders_orders-wrapper__-8ZZL"};